var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-grades",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-grades:not(.animated) .animable {opacity: 0;}svg#freepik_stories-grades.animated #freepik--background-complete--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-grades.animated #freepik--Floor--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-grades.animated #freepik--Character--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-grades.animated #freepik--Plant--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-grades.animated #freepik--Grade--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5",
    className: "animable",
    style: {
      transformOrigin: "247.39px 299.229px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.12,252.32s-7.92-.57-7.19,17.19,2.54,27.23,2.54,27.23-.24,3.93-3.29,3.16-8.79-4.6-11.62-1.74-1.89,7.53,2,12.9,12,17.44,12.73,18.54,1,3.09-1.16,2.89-16.75-5.14-18.69,1.93,11.39,20.24,12.82,21.71,1.5,2.39.92,3.28-5.32-1.24-9.53-2.47-9.31-1.94-10.08,2.23,5.09,16.38,27.06,29.2l10.57,5.28,10-6.38c20.58-15,25.19-27.69,24-31.76S429,352.64,425,354.29s-8.58,4.24-9.25,3.42-.68-1.76.6-3.36,13.21-16,10.58-22.88-16.66-.46-18.79-.05-2.05-1.62-1.45-2.76,7.48-14,10.82-19.72,3.93-10.38.71-13-8.44,1.82-11.39,2.9-3.59-2.83-3.59-2.83.86-9.59-.19-27.34S394,252.32,394,252.32",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "399.439px 322.972px"
    },
    id: "elua0u9nyrl9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.74,268.23s0,.12,0,.37.05.62.09,1.09c.06,1,.16,2.39.28,4.19.24,3.65.56,8.92.92,15.44.72,13,1.57,31.05,2.44,50.95s1.67,37.93,2.32,51c.33,6.51.6,11.78.78,15.44.09,1.81.16,3.22.21,4.2,0,.47,0,.83.05,1.1a3.49,3.49,0,0,1,0,.37s0-.13,0-.37-.05-.63-.09-1.09c-.06-1-.16-2.39-.28-4.2-.25-3.64-.56-8.91-.92-15.43-.72-13-1.57-31.06-2.44-51s-1.67-37.92-2.32-51c-.33-6.5-.6-11.77-.79-15.44-.08-1.81-.16-3.22-.2-4.2,0-.46,0-.83-.05-1.09A3.39,3.39,0,0,1,394.74,268.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.285px 340.305px"
    },
    id: "elt4bslateuwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,303.85a3.4,3.4,0,0,1,.66.54c.41.37,1,.93,1.68,1.61,1.39,1.39,3.27,3.35,5.3,5.55l5.17,5.65,1.57,1.71a3.59,3.59,0,0,1,.55.65,3.4,3.4,0,0,1-.66-.54c-.41-.37-1-.92-1.67-1.62-1.38-1.4-3.23-3.38-5.26-5.58l-5.21-5.62-1.58-1.7A3.59,3.59,0,0,1,382.37,303.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "389.835px 311.705px"
    },
    id: "eldoo2n4kywjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.35,319.21c-.08-.08,3.78-4.12,8.63-9s8.84-8.83,8.92-8.75-3.78,4.12-8.63,9S398.43,319.29,398.35,319.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.125px 310.335px"
    },
    id: "elkc32rbyf8gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.3,349.84a4.07,4.07,0,0,1,.74-.47l2.07-1.16c1.74-1,4.15-2.34,6.75-3.94s4.91-3.11,6.57-4.23l2-1.31a4.23,4.23,0,0,1,.75-.45s-.22.23-.66.58-1.08.83-1.9,1.42c-1.62,1.18-3.91,2.74-6.52,4.34s-5,2.93-6.83,3.84c-.89.46-1.62.82-2.13,1.05A3,3,0,0,1,398.3,349.84Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.74px 344.06px"
    },
    id: "elgzfngidrn25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,339.12a3.13,3.13,0,0,1,.74.35c.45.24,1.11.6,1.91,1.06,1.61.91,3.82,2.2,6.25,3.64s4.61,2.77,6.18,3.75c.79.49,1.42.89,1.85,1.18a3.12,3.12,0,0,1,.65.47,2.59,2.59,0,0,1-.73-.34c-.46-.24-1.11-.61-1.92-1.06-1.6-.92-3.81-2.2-6.24-3.65s-4.61-2.77-6.18-3.74c-.79-.49-1.42-.89-1.85-1.18A2.79,2.79,0,0,1,380.79,339.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "389.58px 344.345px"
    },
    id: "el4zhzxstxvq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,366.16a3.89,3.89,0,0,1,.93.45l2.46,1.35c2.07,1.16,4.91,2.79,8,4.61s5.95,3.49,8,4.71l2.4,1.47a5.14,5.14,0,0,1,.85.59,5.23,5.23,0,0,1-.93-.45l-2.46-1.36c-2.07-1.16-4.92-2.79-8-4.61s-5.95-3.49-8-4.71l-2.4-1.47A5.6,5.6,0,0,1,377.32,366.16Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "388.64px 372.75px"
    },
    id: "elg9prdzahc4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.52,378.87a7.48,7.48,0,0,1,.92-.62l2.57-1.56c2.17-1.32,5.16-3.16,8.4-5.27s6.14-4.1,8.22-5.55l2.47-1.72a6,6,0,0,1,.94-.59,6.69,6.69,0,0,1-.85.72c-.55.44-1.37,1.06-2.39,1.82-2,1.51-4.91,3.54-8.17,5.66s-6.27,3.92-8.47,5.18c-1.11.62-2,1.12-2.64,1.45A6.18,6.18,0,0,1,399.52,378.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.28px 371.215px"
    },
    id: "eltkszyi6r01i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.41 397.11 386.17 397.11 395.71 469.35 405.86 469.35 415.41 397.11",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.79px 433.23px"
    },
    id: "eld9xjelzxi2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.68,406s0,.1.16.26a1.87,1.87,0,0,0,.71.5,3.51,3.51,0,0,0,3.08-.38c1.19-.65,2.21-1.93,3.8-2.49a8.26,8.26,0,0,1,5.37.1,23.09,23.09,0,0,1,5,2.43,35.64,35.64,0,0,0,4.07,2.18,11.09,11.09,0,0,0,3,.87,5,5,0,0,0,.85.06q.3,0,.3,0a15.08,15.08,0,0,1-4-1.2,38.94,38.94,0,0,1-4-2.26,22.43,22.43,0,0,0-5.1-2.5,8.56,8.56,0,0,0-5.67-.06,7.45,7.45,0,0,0-2.14,1.32,15.43,15.43,0,0,1-1.67,1.29,3.47,3.47,0,0,1-2.85.5A3.17,3.17,0,0,1,387.68,406Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "400.85px 406.293px"
    },
    id: "elvuxvswqs3nn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.75,419.3s.23-.3.69-.78a6.59,6.59,0,0,1,2.34-1.48,10.37,10.37,0,0,1,4.06-.61,40.79,40.79,0,0,1,5.09.69,17.83,17.83,0,0,0,5.21.22,14.67,14.67,0,0,0,4.1-1.17,12.71,12.71,0,0,0,2.46-1.47,3.37,3.37,0,0,0,.78-.7,25.81,25.81,0,0,1-3.38,1.86,15.18,15.18,0,0,1-4,1,18.12,18.12,0,0,1-5.08-.25,38.45,38.45,0,0,0-5.15-.66,10.27,10.27,0,0,0-4.21.74,6.17,6.17,0,0,0-2.35,1.67,4.38,4.38,0,0,0-.44.64A.86.86,0,0,0,388.75,419.3Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "401.115px 416.65px"
    },
    id: "ele08rn3miz1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.1,426.42a2.42,2.42,0,0,0-.81-.42,8.4,8.4,0,0,0-2.42-.52,15.42,15.42,0,0,0-3.67.21c-1.36.22-2.82.6-4.36.92a18,18,0,0,1-4.35.49,9.57,9.57,0,0,1-3.46-.74,8.11,8.11,0,0,1-2.62-1.95,2.16,2.16,0,0,0,.49.76,6.26,6.26,0,0,0,2,1.49,9.19,9.19,0,0,0,3.58.88,17.21,17.21,0,0,0,4.47-.46c1.55-.33,3-.72,4.34-1a16.87,16.87,0,0,1,3.57-.3A13.2,13.2,0,0,1,412.1,426.42Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "401.255px 425.978px"
    },
    id: "elqf4ojfndxsd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.34,436.44a4.66,4.66,0,0,1,2.83-.29,13.84,13.84,0,0,1,3,1.11A11.42,11.42,0,0,0,408,436.7a10.06,10.06,0,0,0,1.75-1.34,2.92,2.92,0,0,0,.51-.62,23.93,23.93,0,0,1-2.42,1.67,12.12,12.12,0,0,1-6.79,1.44c-2.77-.16-4.89-1.81-6.81-2A4.33,4.33,0,0,0,392,436C391.53,436.2,391.32,436.42,391.34,436.44Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "400.799px 436.551px"
    },
    id: "elw0ky7i7rgve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,450.3a5.52,5.52,0,0,0,2.44-.48c1.47-.49,3.29-1.62,5.42-2.46a8.58,8.58,0,0,1,3.1-.65,5.63,5.63,0,0,1,2.5.57,5.77,5.77,0,0,1,1.81,1.55,1.41,1.41,0,0,0-.28-.61,3.94,3.94,0,0,0-1.37-1.24,5.71,5.71,0,0,0-2.65-.71,8.69,8.69,0,0,0-3.28.64c-2.21.88-4,2-5.37,2.59S393,450.23,393,450.3Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "400.635px 448.286px"
    },
    id: "elri5j22dx1lc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.4,456.75a6.49,6.49,0,0,0,1.85.61,34.68,34.68,0,0,0,4.63.78,34.19,34.19,0,0,0,4.69.13,7,7,0,0,0,1.93-.23c0-.14-3,0-6.58-.38S394.43,456.61,394.4,456.75Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "400.95px 457.515px"
    },
    id: "elzibg4jivcnm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elllt7vnxny"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 142.38,
    width: 88.16,
    height: 129.42,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "130.82px 207.09px",
      transform: "rotate(-13.37deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltyytale7dv8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.06,
    y: 138.67,
    width: 88.16,
    height: 129.42,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "124.14px 203.38px",
      transform: "rotate(-13.37deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2815mylfgr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.89,
    y: 137.58,
    width: 88.16,
    height: 126.95,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "116.97px 201.055px",
      transform: "rotate(-13.37deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.11,259.85s20-13.63,24.91-29.49a23.51,23.51,0,0,1-16.74,7.85S150.15,255.17,144.11,259.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "156.565px 245.105px"
    },
    id: "elt73amkpk9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.57,162c0,.14-15.19,3.87-34,8.34s-34.09,8-34.12,7.84,15.19-3.87,34-8.34S144.54,161.85,144.57,162Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "110.51px 170.09px"
    },
    id: "elpwtgmcpp2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,171c0,.14-15.19,3.88-34,8.34s-34.09,8-34.12,7.84,15.19-3.87,34-8.34S146.66,170.81,146.7,171Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "112.64px 179.089px"
    },
    id: "elfi6o4vcu6u6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,179.91c0,.14-15.19,3.88-34,8.35s-34.09,8-34.12,7.84,15.18-3.88,34-8.35S148.79,179.77,148.83,179.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "114.77px 188.006px"
    },
    id: "elpslgtxwzilr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,188.87c0,.14-15.19,3.88-34,8.35s-34.09,8-34.12,7.84,15.18-3.88,34-8.35S150.92,188.73,151,188.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "116.94px 196.966px"
    },
    id: "el8uroc1ii5ss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09,197.83c0,.14-15.19,3.88-34,8.35S85,214.16,85,214s15.18-3.88,34-8.35S153.05,197.69,153.09,197.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "119.045px 205.916px"
    },
    id: "elngjz5a9vy08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,206.79c0,.14-15.19,3.88-34,8.35s-34.08,8-34.11,7.84,15.18-3.88,34-8.35S155.18,206.65,155.22,206.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.165px 214.886px"
    },
    id: "elyovdlibswlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,215.75c0,.14-15.19,3.88-34,8.35s-34.08,8-34.11,7.84,15.18-3.88,34-8.35S157.31,215.61,157.35,215.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "123.295px 223.846px"
    },
    id: "elkhaf2gf6s6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.48,224.72c0,.14-15.19,3.87-34,8.34s-34.08,8-34.11,7.84,15.18-3.88,34-8.35S159.44,224.58,159.48,224.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "125.425px 232.811px"
    },
    id: "elmg7os6swpyb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5",
    className: "animable",
    style: {
      transformOrigin: "248.26px 469.26px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.26,469.26c0,.14-101.64.26-227,.26s-227-.12-227-.26,101.63-.26,227-.26S475.26,469.11,475.26,469.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.26px 469.26px"
    },
    id: "elyjafqyclcpc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5",
    className: "animable",
    style: {
      transformOrigin: "252.935px 256.906px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.41,434.31,214.08,460l-7.71,19.79a2.64,2.64,0,0,0,1.67,3.48h0a2.62,2.62,0,0,0,2.39-.41c4.34-3.31,20.24-15.55,20.31-17.44.08-2.19,4.26-26.95,4.26-26.95Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "220.594px 458.853px"
    },
    id: "eli84iglom68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj3c5hoq6syj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "219.45px 473.563px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,483.28l22.9-19.58-.13,1.08a3.93,3.93,0,0,1-1.23,2.46c-1.84,1.73-7,6.39-19.07,15.64a2.64,2.64,0,0,1-2.47.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "219.45px 473.563px"
    },
    id: "elpmjg8ok9bb",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elpcvs3a3jnnd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "227.311px 456.157px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.62,454.83a1.6,1.6,0,0,0-.67,2,1.53,1.53,0,0,0,2,.69,1.69,1.69,0,0,0,.7-2.15,1.59,1.59,0,0,0-2.16-.48",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "227.311px 456.157px"
    },
    id: "elhkbp6pefsu",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.18,472.75a7.89,7.89,0,0,0-2-2.25,8,8,0,0,0-2.89-.9c0-.07.33-.23.94-.25a4.18,4.18,0,0,1,2.26.67,4.14,4.14,0,0,1,1.54,1.77C215.25,472.35,215.25,472.73,215.18,472.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.756px 471.05px"
    },
    id: "elig071yvbucd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,476c-.13.1-.86-.83-2.14-1.36a23.3,23.3,0,0,0-2.47-.61,2.94,2.94,0,0,1,2.69.09C212.5,474.7,213.1,475.92,213,476Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.7px 474.877px"
    },
    id: "el27yr9wuioz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.08,468.73a25.8,25.8,0,0,0-3.17-2.32,25.77,25.77,0,0,0-3.7-1.32,7.23,7.23,0,0,1,6.87,3.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.645px 466.898px"
    },
    id: "elyujkp56yrld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.44,461c-.08.15-1.43-.61-3.27-.88s-3.34,0-3.38-.17a6.58,6.58,0,0,1,6.65,1.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.115px 460.249px"
    },
    id: "elt729m16y9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,453.46a12.65,12.65,0,0,0-3.38-1,13.15,13.15,0,0,0-3.5.47c0-.06.28-.35.91-.62a5.75,5.75,0,0,1,5.17.41C221.1,453.07,221.37,453.4,221.32,453.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.883px 452.671px"
    },
    id: "elontk2kbtbdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,451a2.31,2.31,0,0,1,.08-1,6.68,6.68,0,0,1,1.06-2.45,3.05,3.05,0,0,1,1.44-1.28,1.06,1.06,0,0,1,1.16.37,1.76,1.76,0,0,1,.28,1.21,3.75,3.75,0,0,1-3.65,3.06,4.33,4.33,0,0,1-4-2.73,1.51,1.51,0,0,1,.07-1.26,1,1,0,0,1,1.14-.42,3.66,3.66,0,0,1,1.59,1.07,7.5,7.5,0,0,1,1.53,2.19,2.51,2.51,0,0,1,.29.93,12.48,12.48,0,0,0-2.09-2.83,3.48,3.48,0,0,0-1.41-.9.55.55,0,0,0-.63.23,1.05,1.05,0,0,0,0,.82,3.87,3.87,0,0,0,3.48,2.33,3.25,3.25,0,0,0,3.13-2.55,1.23,1.23,0,0,0-.16-.85.58.58,0,0,0-.64-.22,2.78,2.78,0,0,0-1.24,1.07A10.14,10.14,0,0,0,218.15,451Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.3px 448.611px"
    },
    id: "el6ew6yqtay3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.78,184.73a.75.75,0,0,1,0,.34c-.43,1.57-3.13,8.14-4.05,8.11s-3.08-1.44-2.89-2.38,3.64-8.16,3.64-8.16.62-1.1,2.7-.61C316.43,182.1,316.72,185,316.78,184.73Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "313.314px 187.542px"
    },
    id: "el5pqx2w8m75d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,180.81s0,.14-.05.33c-.44,1.58-3.13,8.15-4.05,8.11s-3.08-1.44-2.89-2.37,3.64-8.16,3.64-8.16.62-1.11,2.7-.62C314,178.4,313.36,180.81,313.36,180.81Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "309.938px 183.613px"
    },
    id: "ele344jff187o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34,178.09s0,.14,0,.33c-.43,1.58-3.13,8.15-4.05,8.11s-3.08-1.44-2.89-2.37S307,176,307,176c-.13.23-.3-1.32,2.7-.62C311,175.68,310.34,178.09,310.34,178.09Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "306.948px 180.864px"
    },
    id: "el618nmjzt7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.53,175.47s0,.14,0,.33c-.43,1.58-3.13,8.14-4.05,8.11s-3.08-1.44-2.89-2.37,3.64-8.16,3.64-8.16.62-1.11,2.7-.62C307.16,173.06,306.53,175.47,306.53,175.47Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "303.135px 178.273px"
    },
    id: "elcq0j3xpvnme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.52,188.86a14.25,14.25,0,0,0,1.57-3.09,13.23,13.23,0,0,0,1.15-3.23,14,14,0,0,0-1.57,3.1A12.61,12.61,0,0,0,310.52,188.86Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "311.88px 185.7px"
    },
    id: "elyqueatl12i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,187.35a26,26,0,0,0,2.17-4.43,28.1,28.1,0,0,0,1.76-4.6,26.91,26.91,0,0,0-2.17,4.43A28.1,28.1,0,0,0,306.61,187.35Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "308.575px 182.835px"
    },
    id: "eli8eyqif1bja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elacot0pa0u8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.78,
      transformOrigin: "304.77px 180.935px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.78,185.47A26.48,26.48,0,0,0,305,181a27.39,27.39,0,0,0,1.76-4.6,28,28,0,0,0-2.17,4.42A28.38,28.38,0,0,0,302.78,185.47Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "304.77px 180.935px"
    },
    id: "eldtgeh7pds8j",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,198c.16-.39,2.78-8.17,2.78-8.17l-15-7.39c-.76,1-3.07,11.91-3.07,11.91l.53,3.72s11.38,6.54,11.69,6.6S311.88,198,311.88,198Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "305.625px 193.555px"
    },
    id: "eltyi3h6as1ee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.16,194.64,298.63,189a10,10,0,0,1,.87-7.37l.94-1.72,12.74,5.8s-2.95,4.18-6.19,1.92l2.49,4.84Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "305.734px 187.275px"
    },
    id: "elxxoo0ymj11o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38,192.93c-.07,0,0-.66-.18-1.77a6.38,6.38,0,0,0-2.41-3.83l-1.18-.87,1.42.39,3.28.92h-.07a3.8,3.8,0,0,0,3.69-1.71,1.31,1.31,0,0,0,.14-.3l.19.4c-3.67-1.49-7-2.88-9.28-4-1.16-.57-2.09-1.06-2.71-1.41a3.62,3.62,0,0,1-.94-.62,38.76,38.76,0,0,1,3.84,1.61c2.35,1,5.66,2.35,9.34,3.84l.28.11-.1.29a2.2,2.2,0,0,1-.18.41,3.86,3.86,0,0,1-1.95,1.69,5.39,5.39,0,0,1-2.35.33h-.07l-3.26-1,.24-.48a6.41,6.41,0,0,1,2.39,4.21A3.42,3.42,0,0,1,308.38,192.93Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "307.06px 186.53px"
    },
    id: "el7rcuyjmdf24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.44,187.28c.13,0-.09.7.11,1.62a1.21,1.21,0,0,0,1,1,1.81,1.81,0,0,0,1.5-1c.77-1.35,1.56-2.58,2-3.48s.72-1.5.81-1.47,0,.67-.39,1.67a30.76,30.76,0,0,1-1.91,3.64,2.33,2.33,0,0,1-2.09,1.27A1.67,1.67,0,0,1,311.1,189a2.85,2.85,0,0,1,.12-1.3C311.32,187.42,311.4,187.27,311.44,187.28Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "313.982px 187.239px"
    },
    id: "elhngd7iscoet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.49,120.78l-4.39,45a6.61,6.61,0,0,1-7.1,5.94l-10.33-.83a6.6,6.6,0,0,1-6.06-7c.33-5.4.85-12,.85-12s-9.61-1.49-9.73-11.1c-.06-4.6.59-14,1.28-22.59a18.2,18.2,0,0,1,18.15-16.74h.64A17.8,17.8,0,0,1,259.49,120.78Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "241.142px 136.6px"
    },
    id: "elci854eysqf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.44,151.78A22.3,22.3,0,0,0,245,148.22s-3,6.92-12.55,6.05Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "238.72px 151.283px"
    },
    id: "ela760zgh3uu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.09,125.33c.17.18,1.21-.59,2.69-.58s2.56.74,2.72.56-.1-.41-.57-.75a3.77,3.77,0,0,0-2.17-.67,3.55,3.55,0,0,0-2.14.69C226.16,124.93,226,125.25,226.09,125.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "228.807px 124.624px"
    },
    id: "elybw2pr0lt2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,125.33c.17.18,1.21-.59,2.69-.58s2.55.74,2.72.56-.1-.41-.57-.75a3.84,3.84,0,0,0-2.18-.67,3.58,3.58,0,0,0-2.14.69C240.63,124.93,240.48,125.25,240.56,125.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.28px 124.624px"
    },
    id: "el5h57aiud4c5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,133.89a9.69,9.69,0,0,0-2.4-.44c-.38,0-.73-.11-.8-.37a1.84,1.84,0,0,1,.26-1.11c.35-.92.72-1.87,1.11-2.88,1.55-4.08,2.67-7.45,2.51-7.51s-1.56,3.21-3.11,7.3l-1.07,2.88a2.22,2.22,0,0,0-.19,1.48,1,1,0,0,0,.62.56,2.6,2.6,0,0,0,.64.08A10.13,10.13,0,0,0,235.25,133.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "233.727px 127.769px"
    },
    id: "elvqo442lamt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,134.91c-.24,0-.25,1.59-1.62,2.73s-3.08,1-3.09,1.18.38.31,1.1.33a3.94,3.94,0,0,0,2.58-.9,3.43,3.43,0,0,0,1.25-2.28C239.88,135.3,239.71,134.9,239.6,134.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.361px 137.03px"
    },
    id: "elxn3bpwsjwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,117.15c.14.4,1.62.21,3.35.42s3.13.68,3.36.32c.11-.17-.14-.55-.7-.94a5.88,5.88,0,0,0-5.12-.56C240.49,116.64,240.17,117,240.23,117.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.594px 117.033px"
    },
    id: "el03wgwxi1agw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.64,118.39c.26.33,1.27,0,2.5,0s2.26.22,2.49-.13c.11-.17,0-.5-.51-.82a3.62,3.62,0,0,0-4,.12C226.66,117.88,226.52,118.22,226.64,118.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.134px 117.716px"
    },
    id: "eloqvg9jw3gjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05,110.24l.06,0a7.58,7.58,0,0,1,2.81,4.89,1.11,1.11,0,0,0,0,.19c.38,2.74.31,5.53.71,8.27A12.41,12.41,0,0,0,256,131c.83.77,2.3,1.31,3,.4a2.48,2.48,0,0,0,.34-1.26c.51-6.62,2.32-12.49,2.31-19.41a5.87,5.87,0,0,0-2.42-4.75c-1.45-1-3.22-2.11-4.83-1.35s-3.7,3.78-4.95,5",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.35px 118.127px"
    },
    id: "el3rwr5sa7e8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.25,125.12c.16-.07,6.6-2,6.39,4.62s-6.76,5-6.77,4.82S256.25,125.12,256.25,125.12Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "259.257px 129.834px"
    },
    id: "elqfu33ezjeo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,132.13s.11.08.3.18a1.16,1.16,0,0,0,.86,0,2.82,2.82,0,0,0,1.39-2.49,3.8,3.8,0,0,0-.27-1.65,1.34,1.34,0,0,0-.83-.91.59.59,0,0,0-.69.29c-.09.18-.06.32-.09.33s-.14-.12-.08-.39a.75.75,0,0,1,.27-.4.92.92,0,0,1,.64-.15,1.61,1.61,0,0,1,1.17,1.06,3.93,3.93,0,0,1,.33,1.84,3,3,0,0,1-1.76,2.79,1.26,1.26,0,0,1-1-.21C258,132.29,257.93,132.14,258,132.13Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "259.491px 129.795px"
    },
    id: "elahhmddqc1ed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.64,105.68c1.62-2.62-2.82-6.4-6.06-7.42s-7.51.56-10.74,1.63c-2,.67-4.06,1.62-6.21,1.53a14.47,14.47,0,0,1-4.16-1.06,10.61,10.61,0,0,0-4.21-.83,3.94,3.94,0,0,0-3.45,2.19,2.47,2.47,0,0,0,1.66,3.35,3.23,3.23,0,1,0-.86,6c-.94-.71-2.37.46-2.25,1.63a3.38,3.38,0,0,0,2.24,2.49c2.74,1.2,5.94.82,8.77-.14s5.47-2.44,8.28-3.46,7.52-2.87,10.34-1.87c2.08.73,3.53,3.23,4.7,2.68a4,4,0,0,0,2.08-2.95,11.82,11.82,0,0,0-.13-3.75",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.844px 106.936px"
    },
    id: "elkqd4gmnyuu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,104.89c.06,0,.34.49,1.05,1.25a9,9,0,0,0,3.65,2.35,8.26,8.26,0,0,0,6.26-.25c2.24-1,4.15-3,6.35-4.89a13.72,13.72,0,0,1,7.39-3.55,7.58,7.58,0,0,1,6.28,2.18,5.76,5.76,0,0,1,1.49,4.25,4.83,4.83,0,0,1-.28,1.2c-.12.26-.2.39-.22.38a9.92,9.92,0,0,0,.25-1.6,5.63,5.63,0,0,0-1.58-3.92,7.19,7.19,0,0,0-5.88-1.89,13.3,13.3,0,0,0-7,3.45c-2.16,1.84-4.13,3.9-6.52,4.94a8.91,8.91,0,0,1-10.35-2.48,7,7,0,0,1-.69-1C220.71,105,220.65,104.9,220.67,104.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.909px 104.628px"
    },
    id: "elcf5misxifdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.92,124.84s-.28-.18-.53-.71a4.39,4.39,0,0,1-.33-2.38c.15-2.11,2-4.39,2.26-7.31a6.65,6.65,0,0,0-.73-3.92,5.05,5.05,0,0,0-2.44-2.11,4.33,4.33,0,0,0-2.2-.3c-.52.08-.81.21-.83.16s.23-.24.78-.41a4.16,4.16,0,0,1,2.41.12,5.3,5.3,0,0,1,2.79,2.23,6.93,6.93,0,0,1,.86,4.29,12,12,0,0,1-1.26,4.14,11.85,11.85,0,0,0-1.18,3.18A5.1,5.1,0,0,0,257.92,124.84Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "256.566px 116.288px"
    },
    id: "elfj4707anj2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3,77.76c-.35-.29-1.59-11-1.59-11l9-5.28,14,3.23-2.81,7.84-14.38,7.54Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "211.21px 70.785px"
    },
    id: "eli2g248vngsq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,86.23s22.62-11.76,37.13-13.3c16.11-1.72,32.35,7.87,32.35,7.87l-3.21-42.49S224.58,27,205.31,31.81c-16.34,4.08-32.69,12-32.69,12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "207.78px 58.4244px"
    },
    id: "elin1c5nul2dm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,86.23l0-.73-.06-2.19c-.05-2-.12-4.8-.22-8.45-.17-7.39-.42-18-.73-31v-.13l.12-.06c4.33-2,9.05-4.08,14.13-6A165.38,165.38,0,0,1,203,32.18l2.18-.58,2.25-.46a38.58,38.58,0,0,1,4.6-.65,43.48,43.48,0,0,1,9.51.39A46.65,46.65,0,0,1,231,33.44a43,43,0,0,1,8.93,4.66l.09.06v.13c0,.41.07.86.1,1.3,1.09,14.57,2.14,28.5,3.09,41.19l0,.45-.4-.22a70.38,70.38,0,0,0-14.23-5.91A51.37,51.37,0,0,0,214.75,73a45.2,45.2,0,0,0-12.28,1.78c-3.74,1-7.12,2.18-10.16,3.31-6.06,2.29-10.75,4.4-13.95,5.88l-3.64,1.72-.93.45-.33.14.31-.18.91-.48c.82-.42,2-1,3.62-1.8,3.17-1.52,7.85-3.68,13.91-6,3-1.15,6.42-2.34,10.17-3.37a44.9,44.9,0,0,1,12.38-1.85,51.3,51.3,0,0,1,14,2.13,69.34,69.34,0,0,1,14.35,5.92l-.36.23c-1-12.69-2-26.62-3.13-41.19l-.1-1.31.11.19a42.66,42.66,0,0,0-8.81-4.58,46.24,46.24,0,0,0-9.36-2.54A43.14,43.14,0,0,0,212,31a40,40,0,0,0-4.54.63l-2.22.46-2.17.57A168.46,168.46,0,0,0,186.82,38c-5.07,1.94-9.8,4-14.11,6l.11-.18c.21,13,.38,23.54.5,30.9.05,3.67.09,6.54.12,8.51l0,2.24C173.47,86,173.46,86.23,173.46,86.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.83px 58.3337px"
    },
    id: "eldyyzaeifnsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.06,69.09c-.15,0-.75-7.17-1.34-16S228.76,37,228.9,37s.74,7.16,1.34,16S231.2,69.08,231.06,69.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "229.98px 53.045px"
    },
    id: "elukroh2hci9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.38,66.86c-.14,0-.74-7.17-1.33-16s-1-16-.82-16.06.74,7.16,1.33,16S225.53,66.85,225.38,66.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.3px 50.8298px"
    },
    id: "elvh4gectz85j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.91,66.08c-.14,0-.74-7.17-1.34-16s-1-16.06-.81-16.06.74,7.16,1.33,16S220.05,66.07,219.91,66.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.826px 50.05px"
    },
    id: "elfgy7lb414b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.68,67.65c-.14,0-.74-7.17-1.34-16s-1-16-.81-16.06.74,7.16,1.33,16S208.82,67.64,208.68,67.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "207.596px 51.6198px"
    },
    id: "el4s2xnd7mlrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.45,69.09c-.14,0-.74-7.16-1.33-16S201.16,37,201.3,37s.74,7.17,1.34,16S203.6,69.08,203.45,69.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "202.377px 53.045px"
    },
    id: "el7d4p8u5zcd3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.89,70.51c-.15,0-.74-7.17-1.34-16s-1-16.06-.82-16.06.75,7.16,1.34,16S198,70.5,197.89,70.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "196.799px 54.48px"
    },
    id: "elxnwp9yqyuns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,74.88c-.15,0-.75-7.16-1.34-16s-1-16.05-.82-16.06.74,7.17,1.34,16S187.44,74.87,187.3,74.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.214px 58.85px"
    },
    id: "elzul548fxnyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.36,72.51c-.15,0-.74-7.16-1.34-16s-1-16.06-.82-16.07.75,7.17,1.34,16S192.5,72.51,192.36,72.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "191.273px 56.475px"
    },
    id: "ely4e75mrqir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,76.78c-.14,0-.74-7.17-1.33-16s-1-16-.82-16.06.74,7.16,1.34,16S181.54,76.77,181.39,76.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "180.311px 60.7498px"
    },
    id: "elc80snw2ajd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.14,66.24c-.14,0-.74-7.17-1.34-16s-1-16.05-.81-16.06.74,7.16,1.33,16S214.28,66.23,214.14,66.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "213.056px 50.21px"
    },
    id: "el2ynn8pgyfsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67,66.58a16.41,16.41,0,0,1,3.7-1.36c2.34-.73,5.61-1.69,9.31-2.71l-.15.93-1.46-.92c-7.18-4.45-13.87-6.27-13.77-6.58,0-.13,1.74.17,4.41,1a48.34,48.34,0,0,1,9.9,4.65c.52.31,1,.64,1.49.95a.52.52,0,0,1-.15.93c-3.71,1-7,1.82-9.4,2.38A15.84,15.84,0,0,1,221.67,66.58Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "227.313px 61.2454px"
    },
    id: "eloo0m0vq1no",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.19,65.44c-.28,0-.75-2.34-1-5.28s-.3-5.36,0-5.39.75,2.33,1,5.28S227.48,65.41,227.19,65.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "226.688px 60.1049px"
    },
    id: "elg38e8kd2j8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.1,63.55s.12.18.23.58a3.2,3.2,0,0,1-.11,1.8,4.89,4.89,0,0,1-1.76,2.26,8.06,8.06,0,0,1-1.53.92,8.42,8.42,0,0,1-1.92.59,10.76,10.76,0,0,1-4.57-.12A16.08,16.08,0,0,1,223,68.8a10.94,10.94,0,0,1-6.18-5.67,9.11,9.11,0,0,1-1-6.19,4.83,4.83,0,0,1,1.84-2.8,6.65,6.65,0,0,1,3-1.12,15,15,0,0,1,13.8,5.69,11.49,11.49,0,0,1,2.29,6.08,7,7,0,0,1-.06,2.38,22,22,0,0,1-.34-2.33,11.75,11.75,0,0,0-2.47-5.67,14.35,14.35,0,0,0-7.68-4.85,14,14,0,0,0-5.38-.3,5.89,5.89,0,0,0-2.54,1,3.76,3.76,0,0,0-1.44,2.21,8.14,8.14,0,0,0,.92,5.48,11,11,0,0,0,3.39,4.11,13,13,0,0,0,8.72,2.2,7.52,7.52,0,0,0,3.24-1.26,4.8,4.8,0,0,0,1.73-1.93,3.64,3.64,0,0,0,.28-1.63A1.61,1.61,0,0,1,235.1,63.55Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "226.239px 61.3916px"
    },
    id: "ele8y3xmbtbbw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,81.81l4.51-3.65a9.81,9.81,0,0,0,3.57-6.4l.25-1.92L207.17,67.1s-1.27,4.1,3.83,5.12c-4.52,2-6.21,6-7.45,10.49Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "212.135px 74.905px"
    },
    id: "el10i160czxdaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.8,75.68c.07,0,.36-.56,1.18-1.31a6.22,6.22,0,0,1,4.14-1.67l1.45,0-1.36-.51L209.05,71l.06,0a3.76,3.76,0,0,1-2-3.51,1.84,1.84,0,0,1,.06-.32l-.38.21c3.8.94,7.24,1.73,9.76,2.16,1.26.22,2.28.37,3,.44a3.91,3.91,0,0,0,1.11.06,37,37,0,0,0-4-.94c-2.48-.54-5.9-1.4-9.7-2.35l-.29-.07-.09.28a2.39,2.39,0,0,0-.09.45,3.71,3.71,0,0,0,.58,2.47,5.23,5.23,0,0,0,1.69,1.63l0,0h0l3.18,1.1.09-.52a6.31,6.31,0,0,0-4.35,2A3.46,3.46,0,0,0,206.8,75.68Z",
    style: {
      fill: "rgb(209, 115, 74)",
      transformOrigin: "213.562px 71.18px"
    },
    id: "el3qt45bzwrun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.78,443.81l19.45-154-3.73-23.34H215.43L210.77,441a2.82,2.82,0,0,0,2.28,2.85l21.36,3.29A3.82,3.82,0,0,0,238.78,443.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.499px 356.827px"
    },
    id: "eln1xkhg4xi4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.67,295l35.38,35-50.9,12.37L245.77,368l68.89-9.37a21.7,21.7,0,0,0,14.67-8.81h0a21.69,21.69,0,0,0,.33-24.88L276,246.19,252,254Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.785px 307.095px"
    },
    id: "elkqqmkawg5pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72,286.06a20.35,20.35,0,0,1,1.23,4.4,20.1,20.1,0,0,1,.72,4.51,20.35,20.35,0,0,1-1.23-4.4A20.1,20.1,0,0,1,255.72,286.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "256.695px 290.515px"
    },
    id: "el1qq8qmjnpa9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57,345.59s.28-.11.84-.28l2.47-.77,9.5-2.89,34.54-10.39-.09.33-42.47-45.21.45-.15c-.85,7.11-1.72,14.52-2.62,22.09-4.38,36.68-8.49,69.87-11.68,93.87-1.58,12-3,21.69-4,28.38-.57,3.34-.94,5.94-1.33,7.68l-.42,2c-.1.44-.16.67-.16.67a6.84,6.84,0,0,1,.11-.69c.08-.46.21-1.12.37-2,.35-1.74.69-4.35,1.23-7.69,1-6.7,2.29-16.4,3.83-28.4,3.09-24,7.14-57.2,11.52-93.88.9-7.57,1.78-15,2.63-22.09l.06-.55.38.4,42.38,45.3.22.24-.31.09-34.59,10.22-9.52,2.78-2.5.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "266.965px 363.27px"
    },
    id: "elux5ol5j3p6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12,440.91c-.15,0,3.89-32.71,9-73s9.39-73,9.53-72.94-3.89,32.69-9,73S239.26,440.92,239.12,440.91Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "248.385px 367.94px"
    },
    id: "el1wld19osp93",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.93,269.76a11,11,0,0,1,.82,2.39c.43,1.49,1,3.58,1.48,5.9s.88,4.44,1.11,6a11.41,11.41,0,0,1,.25,2.51,12.07,12.07,0,0,1-.61-2.44c-.36-1.71-.79-3.72-1.26-5.94l-1.33-5.92A12.93,12.93,0,0,1,251.93,269.76Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.76px 278.16px"
    },
    id: "eluv35inzm1kf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,266.74s.5-.48,1.44-.15a1.65,1.65,0,0,1,1.07,1.27,1.82,1.82,0,0,1-.8,1.87,1.78,1.78,0,0,1-2-.2,1.5,1.5,0,0,1-.46-1.6,1.45,1.45,0,0,1,.66-.88c.23-.13.38-.13.39-.1s-.54.28-.7,1.07a1.15,1.15,0,0,0,.41,1.14,1.33,1.33,0,0,0,1.46.13,1.41,1.41,0,0,0,.6-1.36,1.32,1.32,0,0,0-.75-1A2.87,2.87,0,0,0,254.2,266.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "255.061px 268.211px"
    },
    id: "elbgtpjlday2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,336c-.1.12-2.1-1.71-5-3.36s-5.43-2.5-5.39-2.65a19.45,19.45,0,0,1,10.35,6Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "298.265px 332.998px"
    },
    id: "el58re1yh12uw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.87,266l-3.44-61.21s-5.13-22.05-9.56-30.91l23.39-17.14,6.06,2.91,12,10.91,12.14-7.09s14.54,6.12,18.37,8.42,4.59,8.42,4.59,8.42-12.61,22.22-13,30.94,12.61,31,12.61,31,7.11,2.11,7.51,7.83c.35,4.95-1.95,6.72-1.95,6.72s-1-5.38-8.23-3.08S253,269.41,242.15,269.79,214.87,266,214.87,266Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "243.723px 213.277px"
    },
    id: "elwqnx7j9n9uc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.78,177.7,287,215.5l10.48-25,14.86,9s-14,49.81-27.88,44.91c0,0-8.64-4.37-9.7-7.47s-17.08-25.69-17.08-25.69Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "285.01px 211.225px"
    },
    id: "elyilosi4fig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,242.25s-.13-.14-.32-.42l-.84-1.23c-.36-.54-.81-1.2-1.26-2s-1-1.69-1.53-2.74-1.13-2.16-1.66-3.42-1.1-2.61-1.64-4.05a62.86,62.86,0,0,1-2.57-9.67,65.66,65.66,0,0,1-.89-10c0-1.54,0-3,.11-4.37s.21-2.63.32-3.79c.27-2.31.56-4.17.84-5.44.12-.58.22-1.07.31-1.46a1.71,1.71,0,0,1,.14-.5,2,2,0,0,1,0,.52c-.06.4-.13.89-.21,1.48-.21,1.28-.45,3.14-.67,5.44-.09,1.15-.23,2.41-.25,3.77s-.08,2.81-.07,4.34a68.76,68.76,0,0,0,.93,9.89,63.83,63.83,0,0,0,2.51,9.6c.52,1.43,1,2.8,1.58,4s1.08,2.38,1.58,3.43,1,1.94,1.46,2.75.85,1.49,1.18,2.05l.75,1.29A2.51,2.51,0,0,1,278,242.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.645px 217.705px"
    },
    id: "elgvobjaq9lfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.86,74.71s-23.4,39.32-25,45.12c-1.68,6,30.81,57.39,30.81,57.39s.63,1.65.64,1.64l23.22-18.55-27.37-38.73L214.87,82.9Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "200.164px 126.785px"
    },
    id: "elfb6b1lxw8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,123.15c-.08.06-.57-.64-1.6-1.52a11.56,11.56,0,0,0-9.87-2.47c-1.32.29-2.09.68-2.13.59a5.22,5.22,0,0,1,2-1,9.68,9.68,0,0,1,2.43-.38,11.56,11.56,0,0,1,3,.33,12.22,12.22,0,0,1,2.8,1.12,10.3,10.3,0,0,1,2,1.48A5.31,5.31,0,0,1,201.11,123.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.31px 120.76px"
    },
    id: "elq2kk9scg6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.74,180.4c-.1,0-.05-1.37-.42-3.52a22.41,22.41,0,0,0-1-3.71,23,23,0,0,0-4.82-8,23.34,23.34,0,0,0-2.83-2.57c-1.75-1.32-3-1.92-2.93-2a3.62,3.62,0,0,1,.89.37,9.14,9.14,0,0,1,1,.53,14.44,14.44,0,0,1,1.26.81,20.5,20.5,0,0,1,3,2.54,23.43,23.43,0,0,1,2.91,3.8,22.89,22.89,0,0,1,2,4.34,20.72,20.72,0,0,1,.88,3.8,14.81,14.81,0,0,1,.13,1.49,7.19,7.19,0,0,1,0,1.13A3.09,3.09,0,0,1,211.74,180.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.785px 170.5px"
    },
    id: "el9kdahkkraei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28,243.39c0,.06-.73,0-2,.08a17.58,17.58,0,0,0-5.26,1.37,32.78,32.78,0,0,0-6.93,4.16c-2.44,1.84-5,4.08-7.91,6.1a23.52,23.52,0,0,1-9.16,4.06,25.12,25.12,0,0,1-8.19.09,31.09,31.09,0,0,1-5.37-1.28c-.62-.21-1.09-.39-1.41-.52a2.53,2.53,0,0,1-.47-.22,18.72,18.72,0,0,1,1.94.54,36,36,0,0,0,5.35,1.12,25.43,25.43,0,0,0,8-.21,23.3,23.3,0,0,0,9-4c2.9-2,5.44-4.23,7.92-6.06a31.72,31.72,0,0,1,7.08-4.12,16.34,16.34,0,0,1,5.39-1.23,12.59,12.59,0,0,1,1.5,0A2.22,2.22,0,0,1,275.28,243.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.93px 251.395px"
    },
    id: "elaonc6zezji5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.06,232.85a9.87,9.87,0,0,1-.61-2.51,29.88,29.88,0,0,1-.31-6.24,30.27,30.27,0,0,1,1-6.17,9.6,9.6,0,0,1,.88-2.43,20.66,20.66,0,0,1-.52,2.52,40.33,40.33,0,0,0-.81,6.11,39,39,0,0,0,.16,6.16A18.53,18.53,0,0,1,286.06,232.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "286.057px 224.175px"
    },
    id: "elawj20u2iz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf0f516ujkqi"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "247.296px 251.543px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.56,257c.08-2.5,3.06-3.93,5.56-3.78s4.87,1.28,7.37,1.37c4.24.16,8-2.62,11.24-5.32s6.84-5.61,11.08-5.78c.53,0,1.2.09,1.35.61s-.26.91-.62,1.23c-5.22,4.66-10.56,9.41-17,12.14s-14.29,3.16-20.14-.67",
    id: "el5rflmg5fko",
    className: "animable",
    style: {
      transformOrigin: "247.296px 251.543px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el7ep9xsvkazw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "275.289px 217.854px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.54,196.35a48.26,48.26,0,0,0,11.13,33.7c1.31,1.55,2.76,3.08,3.4,5s.21,4.4-1.57,5.38a4.33,4.33,0,0,1-4.73-.76,11.58,11.58,0,0,1-2.82-4.19c-5.9-12.62-8.82-27.19-5-40.59",
    id: "eljjivogexupg",
    className: "animable",
    style: {
      transformOrigin: "275.289px 217.854px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5",
    className: "animable",
    style: {
      transformOrigin: "123.927px 382.114px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.2,398.42c1-3.36,3.05-6.6,6.26-8s7.2-.62,10.62.62,6.77,2.91,10.4,3.13,7.72-1.5,8.81-5c1-3.27-.95-6.74-3.41-9.11a21.5,21.5,0,0,0-35.23,8.45",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "170.104px 386.233px"
    },
    id: "eldyat76ng6tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu5s1d34hh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "170.104px 386.233px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.2,398.42c1-3.36,3.05-6.6,6.26-8s7.2-.62,10.62.62,6.77,2.91,10.4,3.13,7.72-1.5,8.81-5c1-3.27-.95-6.74-3.41-9.11a21.5,21.5,0,0,0-35.23,8.45",
    id: "elbtdzktsbhes",
    className: "animable",
    style: {
      transformOrigin: "170.104px 386.233px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,413c-5.33-5.05-5.06-13.86-2.41-20.7s8.46-12.1,14.93-15.57a47.27,47.27,0,0,1,41.19-1.33,19.55,19.55,0,0,0-15.81,9.28c-2.91,4.85-3.56,10.73-6,15.84A24.93,24.93,0,0,1,124.46,413",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "149.189px 393.068px"
    },
    id: "eleksivsxt6kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,382.61c-5.89-6.95-6.68-18.12-5.81-27.2s3-18.21,1.54-27.21c-.85-5.34-2.92-10.43-3.62-15.79s.29-11.41,4.44-14.87c4.77-4,12.28-3,17.25.7s7.83,9.59,9.93,15.43c4.62,12.84,6.32,27.07,2.52,40.17s-12.69,24.82-25.74,28.77",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "132.023px 338.789px"
    },
    id: "ellj5slw5iwfa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,439.69a4.85,4.85,0,0,1,0-.8c0-.52,0-1.3,0-2.3.08-2,.27-4.88.72-8.42a110.79,110.79,0,0,1,2.26-12.34,57.18,57.18,0,0,1,5.63-14.29,59.26,59.26,0,0,1,9.2-12.3,58.51,58.51,0,0,1,9.65-8c1.47-1,2.89-1.79,4.12-2.51s2.35-1.2,3.25-1.63l2.12-.89a4.61,4.61,0,0,1,.75-.28,6.05,6.05,0,0,1-.71.37l-2.08,1c-.88.46-2,1-3.2,1.7s-2.61,1.53-4.06,2.56a60.27,60.27,0,0,0-18.61,20.27c-5.42,9.48-6.91,19.45-8,26.43-.49,3.53-.74,6.4-.87,8.39-.06,1-.1,1.73-.13,2.29A5,5,0,0,1,119.07,439.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.912px 407.81px"
    },
    id: "elpjl28pyfks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24,355.17c-10.91,6.58-10.87,12.57-9,18.22s8.51,9.58,14.06,7.46c3.13-1.2,5.41-3.92,7.35-6.66s3.76-5.67,6.48-7.64,6.66-2.72,9.39-.77",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "77.4085px 368.301px"
    },
    id: "elq0eow1lxdse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elovnh5c9euql"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "77.4085px 368.301px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.24,355.17c-10.91,6.58-10.87,12.57-9,18.22s8.51,9.58,14.06,7.46c3.13-1.2,5.41-3.92,7.35-6.66s3.76-5.67,6.48-7.64,6.66-2.72,9.39-.77",
    id: "eldnokse2y904",
    className: "animable",
    style: {
      transformOrigin: "77.4085px 368.301px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M60.07,362.38c2.85-3.94,9.9-5.08,14.34-3.11S82.12,365.13,85,369s5.75,8,9.79,10.71,9.68,3.69,13.71,1a11.77,11.77,0,0,0,4.65-8.06,26.79,26.79,0,0,0-.64-9.51c-1-4.57-2.53-9.35-6.19-12.25-4.08-3.24-9.74-3.39-14.94-3.22-6,.19-12,.64-17.64,2.71s-11.33,6.54-13.71,12",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "86.6734px 364.963px"
    },
    id: "elom16fs5solr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,431a.75.75,0,0,1,0-.24c0-.19,0-.42,0-.7,0-.66,0-1.57-.09-2.71-.07-2.39-.17-5.78-.29-9.95s-.3-9.21-.61-14.75-.72-11.65-1.56-18a57.86,57.86,0,0,0-1.81-9.13A48.37,48.37,0,0,0,98,360.86a44.37,44.37,0,0,0-4.61-5.05,33.36,33.36,0,0,0-8.16-5.56c-.53-.25-1-.49-1.41-.66l-1.07-.41-.65-.26-.22-.11.24.06.67.22,1.08.37c.43.15.9.38,1.44.61a32.7,32.7,0,0,1,8.32,5.48,43.23,43.23,0,0,1,4.69,5.07,46.13,46.13,0,0,1,4.29,6.65,47.7,47.7,0,0,1,3.4,8.06,57.43,57.43,0,0,1,1.83,9.22c.85,6.37,1.25,12.48,1.53,18s.42,10.56.51,14.77.11,7.61.13,10V430c0,.29,0,.52,0,.71A1.1,1.1,0,0,1,110,431Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.9476px 389.905px"
    },
    id: "elyknie3akgv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.93,435.89a31.07,31.07,0,0,1-1.19-4.69,48.81,48.81,0,0,1-.5-13.15A87.42,87.42,0,0,1,116.39,399c2.24-7,5.28-14.52,7.87-22.58a103.46,103.46,0,0,0,3.13-11.95,107.42,107.42,0,0,0,1.55-11.4,166.4,166.4,0,0,0,.35-19.49c-.19-5.56-.49-10.05-.67-13.15l-.21-3.57c0-.39,0-.7,0-.93a1.3,1.3,0,0,1,0-.32,1.8,1.8,0,0,1,0,.31c0,.24.05.54.09.93q.11,1.28.3,3.57c.24,3.1.59,7.59.82,13.15a160.94,160.94,0,0,1-.24,19.54,105.89,105.89,0,0,1-1.53,11.45,103.32,103.32,0,0,1-3.13,12c-2.61,8.09-5.66,15.58-7.91,22.57a89,89,0,0,0-4.24,19,51,51,0,0,0,.34,13.09c.27,1.53.52,2.71.73,3.5.09.38.17.68.22.9A1.24,1.24,0,0,1,113.93,435.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "120.909px 375.75px"
    },
    id: "el6o8e1pgad1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.96 440.81 89.76 440.81 88.59 430.96 140.96 430.96 140.96 440.81",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "114.775px 435.885px"
    },
    id: "el9ifnnzomfnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.26 439.69 101.66 469.26 129.48 469.26 135.47 439.69 95.26 439.69",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.365px 454.475px"
    },
    id: "el3xp4f0a0v8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,440.81c0,.14-11.25.22-25.14.18s-25.14-.18-25.14-.32,11.26-.21,25.15-.17S141,440.68,141,440.81Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.86px 440.745px"
    },
    id: "elfwb2zo9khqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18,455.41a21.52,21.52,0,0,0-4.51-2.59,16,16,0,0,0-5.49-1.1,19.31,19.31,0,0,0-6.74,1.24c-2.33.79-4.51,1.71-6.63,2.21a15.66,15.66,0,0,1-5.74.17,11.71,11.71,0,0,1-3.68-1.16,6.09,6.09,0,0,1-.89-.57c-.19-.14-.29-.22-.28-.24s.44.26,1.25.64a12.86,12.86,0,0,0,3.65,1,16,16,0,0,0,5.59-.27c2.05-.51,4.23-1.44,6.58-2.23a19.24,19.24,0,0,1,6.91-1.23,16,16,0,0,1,5.6,1.23,14.43,14.43,0,0,1,3.33,1.95,9.15,9.15,0,0,1,.8.68C132.1,455.3,132.19,455.39,132.18,455.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.2px 453.403px"
    },
    id: "elfr33qw8m76m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.79,457.38a22.82,22.82,0,0,0-4.33-2.55,14.75,14.75,0,0,0-5.29-1.09,19.07,19.07,0,0,0-6.52,1.17c-2.26.76-4.37,1.63-6.39,2.18a16.69,16.69,0,0,1-5.52.62,9.4,9.4,0,0,1-3.61-1,6.26,6.26,0,0,1-.86-.55c-.19-.14-.28-.22-.27-.23s.43.25,1.21.61a10,10,0,0,0,3.56.79,16.6,16.6,0,0,0,5.36-.71c2-.55,4.08-1.44,6.37-2.2a19,19,0,0,1,6.68-1.16,14.63,14.63,0,0,1,5.41,1.22,14.26,14.26,0,0,1,3.2,1.94,7.61,7.61,0,0,1,.76.67C131.72,457.28,131.8,457.37,131.79,457.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "115.395px 455.498px"
    },
    id: "elg2an78rwx4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,453.45a23.58,23.58,0,0,0-4.63-2.73,16.93,16.93,0,0,0-5.62-1.35,18,18,0,0,0-7,1.22,64.42,64.42,0,0,1-6.87,2.25,17.82,17.82,0,0,1-5.93,0,13.35,13.35,0,0,1-3.8-1.21,6.77,6.77,0,0,1-.92-.57c-.2-.15-.3-.23-.29-.25s.45.27,1.29.65a15.07,15.07,0,0,0,3.78,1,18,18,0,0,0,5.78-.11,69.43,69.43,0,0,0,6.8-2.27,18,18,0,0,1,7.14-1.21,16.66,16.66,0,0,1,5.73,1.48,16.15,16.15,0,0,1,3.42,2.06,9.31,9.31,0,0,1,.82.71C132.61,453.34,132.69,453.43,132.68,453.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "115.15px 451.155px"
    },
    id: "el5qdaaeniz16",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.42,440.86c0,.13-11.52.24-25.73.24S90,441,90,440.86s11.52-.25,25.72-.25S141.42,440.72,141.42,440.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.71px 440.855px"
    },
    id: "eloc7zlbehtl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Grade--inject-5",
    className: "animable",
    style: {
      transformOrigin: "371.091px 154.576px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.84,200.75a7.65,7.65,0,0,1-1.15-1.91c-.68-1.29-1.65-3.21-2.88-5.7-2.46-5-6-12.23-10.26-21.28-8.6-18.1-20.43-43.36-33.63-71.9l2.36,0c-1.8,4.19-3.72,8.6-5.52,13.14-3.25,8-6.22,16-8.84,23.7-1.36,3.86-2.55,7.69-3.77,11.43s-2.29,7.44-3.31,11c-4.14,14.44-7.2,27.63-9.43,38.78s-3.65,20.24-4.63,26.53c-.49,3.15-.82,5.6-1.11,7.25a10.56,10.56,0,0,1-.55,2.51,9.35,9.35,0,0,1,0-2.57c.12-1.67.29-4.15.62-7.32.67-6.34,1.83-15.5,3.83-26.74s4.89-24.54,8.93-39.09c1-3.64,2.12-7.35,3.25-11.14s2.37-7.63,3.72-11.51c2.61-7.79,5.58-15.77,8.84-23.86,1.82-4.56,3.76-9,5.57-13.2a1.29,1.29,0,0,1,1.7-.67,1.23,1.23,0,0,1,.65.64h0c13.14,28.57,24.68,54,32.86,72.25,4.09,9.15,7.35,16.52,9.54,21.62,1.09,2.55,1.92,4.53,2.46,5.88A8.05,8.05,0,0,1,408.84,200.75Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "367.436px 166.196px"
    },
    id: "elj526twe75oa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,157.67c.19.7-18.63,6.42-42,12.78s-42.54,11-42.73,10.26,18.63-6.42,42.05-12.78S391.91,157,392.1,157.67Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "349.735px 169.196px"
    },
    id: "elomfqj7f47z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,78.14a5.37,5.37,0,0,1,1.21-.69l1.53-.76c.62-.28,1.37-.55,2.21-.88a35.75,35.75,0,0,1,6.45-1.71,33.07,33.07,0,0,1,9.12-.1,35.52,35.52,0,0,1,10.92,3.4,49.64,49.64,0,0,1,11.13,7.83A67.74,67.74,0,0,1,431.7,97.12a28.68,28.68,0,0,1,2.13,3.66c.64,1.27,1.31,2.55,1.95,3.86l1.72,4.1c.6,1.38,1,2.84,1.52,4.29a80.77,80.77,0,0,1,3.66,18.9,101.28,101.28,0,0,1-.74,20.83,150.58,150.58,0,0,1-4.73,21.78c-.5,1.85-1.13,3.67-1.69,5.53s-1.32,3.7-2,5.57c-.81,1.81-1.56,3.66-2.45,5.47l-1.39,2.69-.69,1.35-.78,1.31a107,107,0,0,1-15,19.9,126.1,126.1,0,0,1-19.74,16.83A114.11,114.11,0,0,1,369.86,246a69.82,69.82,0,0,1-27.35,4.95,43.74,43.74,0,0,1-13.91-2.73,34.91,34.91,0,0,1-11.9-7.49,37.88,37.88,0,0,1-4.59-5.23,45.35,45.35,0,0,1-3.64-5.83,64.86,64.86,0,0,1-5-12.51,118.84,118.84,0,0,1-2.64-50.5,134.62,134.62,0,0,1,5.77-22.94c.33-.9.65-1.8,1-2.7s.64-1.79,1-2.66q1.09-2.61,2.16-5.19l2.38-5c.76-1.67,1.7-3.23,2.53-4.83A132.58,132.58,0,0,1,327,105.89l1.5-2,1.57-1.9c1.06-1.25,2.06-2.52,3.13-3.71l3.21-3.5c1-1.18,2.2-2.21,3.27-3.3,2.14-2.19,4.46-4.09,6.62-6l3.38-2.68,1.66-1.31,1.7-1.2,3.34-2.34,3.35-2.1,1.63-1,1.66-.93,3.24-1.79c2.15-1.12,4.28-2.12,6.31-3.1s4.06-1.76,6-2.53l5.59-2.07,5.14-1.64c6.54-1.93,11.7-3.08,15.22-3.75,1.76-.32,3.11-.56,4-.7a4.79,4.79,0,0,1,1.38-.15,5.87,5.87,0,0,1-1.33.41c-.89.23-2.22.55-4,.95-3.47.84-8.58,2.14-15,4.21l-5.06,1.74L379,67.61c-1.9.8-3.84,1.7-5.89,2.6s-4.07,2-6.18,3.16l-3.17,1.82-1.63.93-1.6,1-3.28,2.11L354,81.62l-1.66,1.2-1.62,1.3-3.3,2.67c-2.11,1.94-4.37,3.83-6.45,6-1.05,1.08-2.19,2.1-3.2,3.27s-2.08,2.3-3.13,3.48-2,2.45-3.05,3.68l-1.54,1.89-1.46,2a130.66,130.66,0,0,0-11.05,17.26c-.81,1.58-1.72,3.12-2.46,4.76l-2.31,4.94-2.09,5.12c-.37.85-.69,1.73-1,2.62l-.93,2.66A133.59,133.59,0,0,0,303.22,167a120.3,120.3,0,0,0-1.3,24.35,111.69,111.69,0,0,0,4,25.06,62.81,62.81,0,0,0,4.8,12,43.07,43.07,0,0,0,3.45,5.51,35.68,35.68,0,0,0,4.3,4.89,32.75,32.75,0,0,0,11,6.94,41.58,41.58,0,0,0,13.1,2.55,67.7,67.7,0,0,0,26.32-4.77,112.2,112.2,0,0,0,23.14-12.48,124.18,124.18,0,0,0,19.39-16.44,105.14,105.14,0,0,0,14.69-19.39l.76-1.28.68-1.31,1.36-2.61c.87-1.75,1.6-3.55,2.4-5.3.65-1.82,1.36-3.59,1.95-5.41s1.2-3.63,1.7-5.46a148.9,148.9,0,0,0,4.79-21.42,98.88,98.88,0,0,0,.87-20.4,79,79,0,0,0-3.4-18.48c-.49-1.41-.87-2.85-1.44-4.2s-1.1-2.7-1.64-4l-1.86-3.8a27.26,27.26,0,0,0-2-3.54,66.44,66.44,0,0,0-9.72-11.74,48.78,48.78,0,0,0-10.69-7.78A34.76,34.76,0,0,0,399.4,75a32.55,32.55,0,0,0-8.88-.14,37.58,37.58,0,0,0-6.38,1.44c-.84.29-1.59.51-2.23.75l-1.57.64A5.75,5.75,0,0,1,379,78.14Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "371.091px 154.576px"
    },
    id: "elcgwkvmgy7tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.43,144.1c-.72,0-1.93-12-2.69-27S397.93,90,398.65,90s1.92,12,2.69,27S402.14,144.06,401.43,144.1Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "400.04px 117.05px"
    },
    id: "elfwedzxhvkca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.65,110.54c.27.66-7.59,4.5-17.74,8.09s-18.67,5.59-18.87,4.91,7.92-3.77,18-7.36S417.38,109.87,417.65,110.54Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "399.347px 117.055px"
    },
    id: "elz1nyrx3cufg",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.e8ea4fd4b3d43e2e739fa911a83b0590.svg";
export { ForwardRef as ReactComponent };